import { render, staticRenderFns } from "./AdminChart.vue?vue&type=template&id=7995903f&scoped=true&"
import script from "./AdminChart.vue?vue&type=script&lang=js&"
export * from "./AdminChart.vue?vue&type=script&lang=js&"
import style0 from "./AdminChart.vue?vue&type=style&index=0&id=7995903f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7995903f",
  null
  
)

export default component.exports